export default class SortedArray extends Array {
    constructor(comparator = (a, b) => a - b) {
        super();
        this._comparator = comparator;
    }
    insert(value) {
        let left = 0;
        let right = this.length - 1;
        let mid = 0;
        while (left <= right) {
            mid = Math.floor((left + right) / 2);
            if (value === this[mid]) {
                this.splice(mid, 0, value);
                return mid;
            }
            else if (this._comparator(value, this[mid]) > 0) {
                left = mid + 1;
            }
            else {
                right = mid - 1;
            }
        }
        this.splice(left, 0, value);
        return left;
    }
    remove(value) {
        let index = this.indexOf(value);
        if (index === -1) {
            throw new Error("Element doesn't exist");
        }
        else {
            this.splice(index, 1);
            return index;
        }
    }
    removeAt(index) {
        if (index < 0 || index >= this.length) {
            throw new RangeError("Index out of range.");
        }
        let elementRemoved = this[index];
        this.splice(index, 1);
        return elementRemoved;
    }
    exists(value) {
        let index = this.binarySearch(value);
        if (index === -1) {
            return false;
        }
        else {
            return true;
        }
    }
    binarySearch(value, closest = false) {
        let left = 0;
        let right = this.length - 1;
        let mid = 0;
        if (this.length == 0) {
            return -1;
        }
        if (closest && this._comparator(value, this[right]) > 0) {
            return right;
        }
        while (left <= right) {
            mid = Math.floor((left + right) / 2);
            if (this._comparator(value, this[mid]) === 0) {
                while (mid > 0 && this._comparator(this[mid], this[mid - 1]) === 0) {
                    mid = mid - 1;
                }
                return mid;
            }
            else if (this._comparator(value, this[mid]) > 0) {
                left = mid + 1;
            }
            else {
                if (closest && this._comparator(value, this[mid - 1])) {
                    return mid - 1;
                }
                right = mid - 1;
            }
        }
        if (closest) {
            return left;
        }
        else {
            return -1;
        }
    }
}
//# sourceMappingURL=SortedArray.js.map